"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMilitaryTypes = exports.getRuralTypes = exports.getMilitaryCities = exports.getStates = void 0;
const getStates = (API) => {
    const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-miscellaneous/miscellaneous/values/statecode?pageSize=500`;
    return API.GET(url);
};
exports.getStates = getStates;
const getMilitaryCities = (API) => {
    const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-miscellaneous/v1/miscellaneous/values/militarycity`;
    return API.GET(url);
};
exports.getMilitaryCities = getMilitaryCities;
const getRuralTypes = (API) => {
    const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-miscellaneous/v1/miscellaneous/values/ruraladdresstype`;
    return API.GET(url);
};
exports.getRuralTypes = getRuralTypes;
const getMilitaryTypes = (API) => {
    const url = `${window.MIDDLEWARE_BASE_HOST}/mb-api-miscellaneous/v1/miscellaneous/values/militaryaddresstype`;
    return API.GET(url);
};
exports.getMilitaryTypes = getMilitaryTypes;
//# sourceMappingURL=repository.js.map